import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Search, ArrowRight } from "lucide-react";

export default function CitiesIndex() {
  const [states, setStates] = useState([]);
  const [stats, setStats] = useState({ total: 0, us: 0, ca: 0 });
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);

  useEffect(() => {
    api.get("/cities/states").then(r => setStates(r.data));
    api.get("/cities/stats").then(r => setStats(r.data));
  }, []);

  useEffect(() => {
    if (q.length < 2) { setResults([]); return; }
    const t = setTimeout(() => api.get("/cities/search", { params: { q, limit: 15 } }).then(r => setResults(r.data)), 200);
    return () => clearTimeout(t);
  }, [q]);

  const us = states.filter(s => s.country === "US");
  const ca = states.filter(s => s.country === "CA");

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20" data-testid="cities-index">
      <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706]">// Coverage Map</div>
      <h1 className="display-black text-5xl lg:text-6xl uppercase text-[#064E3B] mt-3 tracking-tighter">
        Available in {stats.total.toLocaleString()}+ cities.
      </h1>
      <p className="text-gray-700 mt-4 max-w-2xl">
        {stats.us.toLocaleString()} United States cities. {stats.ca.toLocaleString()} Canadian cities. From Anchorage to Iqaluit, Miami to Victoria — we operate.
      </p>

      <div className="mt-10 max-w-2xl relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" />
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Find your city…"
          className="input-federal pl-9 text-base"
          data-testid="cities-search-input"
        />
        {results.length > 0 && (
          <div className="absolute z-10 left-0 right-0 mt-1 bg-white border border-gray-300 max-h-80 overflow-auto">
            {results.map(c => (
              <Link
                key={c.id}
                to={`/city/${c.slug}`}
                className="block px-4 py-3 hover:bg-gray-50 border-b border-gray-100 text-gray-900 flex justify-between"
                data-testid={`cities-result-${c.slug}`}
              >
                <span><span className="font-semibold">{c.name}</span> <span className="text-gray-500 text-sm">— {c.state}, {c.country}</span></span>
                <ArrowRight className="w-4 h-4 text-gray-400" />
              </Link>
            ))}
          </div>
        )}
      </div>

      <div className="mt-16">
        <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#064E3B] mb-5">// United States · {us.length} States</div>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-px bg-gray-300 border border-gray-300">
          {us.map(s => (
            <Link key={s.code} to={`/cities/${s.code}`} className="bento-card p-5 flex items-center justify-between" data-testid={`state-${s.code}`}>
              <div>
                <div className="font-bold text-sm text-[#064E3B]">{s.name}</div>
                <div className="mono text-[10px] tracking-wider text-gray-500 uppercase">{s.count.toLocaleString()} cities</div>
              </div>
              <ArrowRight className="w-4 h-4 text-gray-400" />
            </Link>
          ))}
        </div>
      </div>

      <div className="mt-16">
        <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706] mb-5">// Canada · {ca.length} Provinces & Territories</div>
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-px bg-gray-300 border border-gray-300">
          {ca.map(s => (
            <Link key={s.code} to={`/cities/${s.code}`} className="bento-card p-5 flex items-center justify-between" data-testid={`province-${s.code}`}>
              <div>
                <div className="font-bold text-sm text-[#064E3B]">{s.name}</div>
                <div className="mono text-[10px] tracking-wider text-gray-500 uppercase">{s.count.toLocaleString()} cities</div>
              </div>
              <ArrowRight className="w-4 h-4 text-gray-400" />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
